<template>
  <v-form
    id="industryDetails"
    v-model="valid"
  >
    <h2 class="header">
      Industry &amp; Job Titles
    </h2>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-autocomplete
          :key="candidateIndustries"
          v-model="candidate.industries"
          :disabled="candidate.is_synced === 1"
          :items="industries"
          class="textField"
          label="Select your preferred industries"
          no-data-text="There are no matching industries. Please select from the list"
          item-text="name"
          item-value="id"
          chips
          filled
          multiple
          deletable-chips
          @keydown.enter.prevent
        >
          <template v-slot:selection="{ item }">
            <v-chip
              close
              @click:close="removeIndustryWithJobTitles(item)"
            >
              {{ item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div
          v-for="industry in industries"
          :key="industry.id"
        >
          <v-autocomplete
            v-if="industrySelected(industry)"
            v-model="candidate.job_titles"
            :label="'Type or Select your preferred ' + industry.name
              + ' jobs'"
            class="textField"
            :items="industry.job_titles"
            item-text="name"
            item-value="id"
            no-data-text="There are no job titles available"
            deletable-chips
            return-object
            multiple
            filled
            chips
          />
        </div>
      </v-col>
    </v-row>
    <v-btn
      tile
      outlined
      color="agency-color-secondary"
      @click="goBack()"
    >
      Back
    </v-btn>
    <v-btn
      tile
      dark
      color="agency-color-primary"
      @click="next()"
    >
      Next
    </v-btn>
  </v-form>
</template>
<script>
export default {
  name: 'IndustryDetails',
  props: {
    candidate: {
      type: Object,
      default: () => {
        return {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    }
  },
  data: () => ({
    valid: false,
    industries: [],
    candidateIndustries: 0
  }),
  created () {
    const context = this
    axios.get(context.URLs.core.industries.root).then(
      response => {
        context.industries = response.data.data
      }
    )
  },
  methods: {
    next () {
      this.$emit('next', {
        newCandidate: this.candidate
      })
      localStorage.setItem('candidate_register', JSON.stringify(this.candidate))
    },
    goBack () {
      this.$emit('back')
    },
    industrySelected (industry) {
      return _.indexOf(this.candidate.industries, industry.id) !== -1
    },
    removeIndustryWithJobTitles (item) {
      _.remove(this.candidate.industries, function (industry) {
        return industry === item.id
      })
      _.remove(this.candidate.job_titles, function (jobTitle) {
        return jobTitle.industry_id === item.id
      })
      this.candidateIndustries += 1
    }
  }
}
</script>
